import React from 'react';
import { ListBlock } from './ListBlock';
import { FilterItem } from '../../model/FilterItem';
import { FilterType } from '../../model/FilterType';
import { Collapsed } from '../../model/Collapsed';

const List = ({ textFilter, type, locations, installations, campaigns, zones, selected, showZones, onAdd, onRemove, onChangeType }: Props) => {
  const onCheckItem = (item: Collapsed, type: FilterType, value: boolean) => {
    if(value && type !== FilterType.location) {
      const selected = getSelected(type);
      for(let i of selected) {
        onRemove(i);
      }
    }
    const e = { value: item.id, type: type, text: item.name };
    value ? onAdd(e) : onRemove(e);
  }

  const getFiltered = (list: Collapsed[]): Collapsed[] => {
    return list.filter(item => item.name.toLowerCase().includes(textFilter.toLowerCase()));
  }

  const getFilteredLocations = (): Collapsed[] => {
    return textFilter ? getFiltered(locations) : locations;
  }

  const getFilteredInstallations = (): Collapsed[] => {
    let filteredInstallations = installations;
    const selectedLocations = getSelected(FilterType.location).map(l => l.value);
    if(selectedLocations.length) {
      const filteredInstallationsMap = new Map<string, any>();
      for(let location of locations) {
        if(selectedLocations.includes(location.id)) {
          console.log('selected location', location);
          for(let installation of (location as any).installations) {
            if(!filteredInstallationsMap.has(installation.id)) {
              filteredInstallationsMap.set(installation.id, installation);
            }
          }
        }
      }
      filteredInstallations = Array.from(filteredInstallationsMap.values());
    }
    return textFilter ? getFiltered(filteredInstallations) : filteredInstallations;
  }

  const getFilteredCampaigns = (): Collapsed[] => {
    let filteredCampaigns = campaigns;
    const selectedInstallations = getSelected(FilterType.installation).map(i => i.value);
    if(selectedInstallations.length) {
      const filteredCampaignsMap = new Map<string, any>();
      for(let location of locations) {
        for(let installation of (location as any).installations) {
          if(selectedInstallations.includes(installation.id)) {
            for(let campaign of installation.campaigns) {
              if(!filteredCampaignsMap.has(campaign.id)) {
                filteredCampaignsMap.set(campaign.id, campaign);
              }
            }
          }
        }
      }
      filteredCampaigns = Array.from(filteredCampaignsMap.values());
    }
    else {
      const selectedLocations = getSelected(FilterType.location).map(l => l.value);
      if(selectedLocations.length) {
        const filteredCampaignsMap = new Map<string, any>();
        for(let location of locations) {
          if(selectedLocations.includes(location.id)) {
            for(let installation of (location as any).installations) {
              for(let campaign of installation.campaigns) {
                if(!filteredCampaignsMap.has(campaign.id)) {
                  filteredCampaignsMap.set(campaign.id, campaign);
                }
              }
            }
          }
        }
        filteredCampaigns = Array.from(filteredCampaignsMap.values());
      }
    }
    return textFilter ? getFiltered(filteredCampaigns) : filteredCampaigns;
  }

  const getFilteredZones = (): Collapsed[] => {
    return textFilter ? getFiltered(zones) : zones;
  }

  const getSelected = (type: FilterType): FilterItem[] => {
    return selected.filter(i => i.type === type);
  }

  return (
    <div>
      {type == FilterType.all || type === FilterType.location ? <ListBlock items={getFilteredLocations()} selected={getSelected(FilterType.location).map(i => i.value)} expanded={type === FilterType.location} onCheck={(item: Collapsed, value: boolean) => onCheckItem(item, FilterType.location, value)} title="LOCATION" icon="location" color="info" onExpand={() => onChangeType(FilterType.location)} /> : ''}
      {type === FilterType.all || type === FilterType.installation ? <ListBlock items={getFilteredInstallations()} selected={getSelected(FilterType.installation).map(i => i.value)} expanded={type === FilterType.installation} onCheck={(item: Collapsed, value: boolean) => onCheckItem(item, FilterType.installation, value)} title="INSTALLATION" icon="rotate-dot" color="warning" onExpand={() => onChangeType(FilterType.installation)} /> : ''}
      {type === FilterType.all || type === FilterType.campaign ? <ListBlock items={getFilteredCampaigns()} selected={getSelected(FilterType.campaign).map(i => i.value)} expanded={type === FilterType.campaign} onCheck={(item: Collapsed, value: boolean) => onCheckItem(item, FilterType.campaign, value)} title="CAMPAIGN" icon="device-analytics" color="info" onExpand={() => onChangeType(FilterType.campaign)} /> : ''}
      {showZones && (type === FilterType.all || type === FilterType.zone) ? <ListBlock items={getFilteredZones()} selected={getSelected(FilterType.zone).map(i => i.value)} expanded={type === FilterType.zone} onCheck={(item: Collapsed, value: boolean) => onCheckItem(item, FilterType.zone, value)} title="ZONE" icon="map-pin" color="info" onExpand={() => onChangeType(FilterType.zone)} /> : ''}
    </div>
  );
}

interface Props {
  textFilter: string,
  type: FilterType,
  locations: Collapsed[],
  installations: Collapsed[],
  campaigns: Collapsed[],
  zones: Collapsed[],
  selected: FilterItem[],
  showZones: boolean,
  onAdd: (item: FilterItem) => void,
  onRemove: (item: FilterItem) => void,
  onChangeType: (type: FilterType) => void
}

export { List };
